import React from 'react';
import AppointmentScheduler from '../appointmentScheduler';
import UserDetails from './userDetails';
import BranchManager from '../branchManager';
import Reports from '../reports';
import AdminAppointments from '../adminAppointments';

const Admin = () => {
    return <div>
        <div className="container mt-3">

            <div class="container mt-5 mb-5">
    <h2 class="mb-4">Admin Dashboard</h2>
    <div class="custom-tabs">
        <div style={{overflowX: 'auto',overflowY:'hidden', WebkitOverflowScrolling: 'touch'}}>
        <ul class="nav nav-tabs" id="myTab" role="tablist" style={{
            backgroundColor:"#1ee576",
            flexWrap: 'nowrap',
            display: 'flex',
            minWidth: 'max-content'
        }}>
            <li class="nav-item cursor-pointer" role="presentation" style={{whiteSpace: 'nowrap'}}>
                <button class="nav-link active " id="home-tab" data-bs-toggle="tab" data-bs-target="#reports" type="button" role="tab" aria-controls="reports" aria-selected="true">Reports​</button>
            </li>
            <li class="nav-item cursor-pointer" role="presentation" style={{whiteSpace: 'nowrap'}}>
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#appointmentSchedule" type="button" role="tab" aria-controls="appointmentSchedule" aria-selected="false">Appointment Schedule</button>
            </li>
            <li class="nav-item cursor-pointer" role="presentation" style={{whiteSpace: 'nowrap'}}>
                <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#userDetails" type="button" role="tab" aria-controls="userDetails" aria-selected="false">User Details</button>
            </li>
            <li class="nav-item cursor-pointer" role="presentation" style={{whiteSpace: 'nowrap'}}>
                <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#appointments" type="button" role="tab" aria-controls="appointments" aria-selected="false">Appointments</button>
            </li>
          
        </ul>
        </div>
        <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="reports" role="tabpanel" aria-labelledby="home-tab">
                {/* <h3 class="mb-3">Welcome Reports</h3> */}
                <Reports />
            </div>
            <div class="tab-pane fade" id="appointmentSchedule" role="tabpanel" aria-labelledby="profile-tab">
                {/* <h3 class="mb-3">Appointment Schedule</h3> */}
                 <AppointmentScheduler />
            </div>
            <div class="tab-pane fade" id="userDetails" role="tabpanel" aria-labelledby="contact-tab">
                <UserDetails />
            </div>
            <div class="tab-pane fade" id="appointments" role="tabpanel" aria-labelledby="contact-tab">
                <AdminAppointments />
            </div>
        </div>
    </div>
</div>
        </div>
    </div>;
};

export default Admin;